import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initializeBox() {
    document.querySelectorAll('.block-box-container').forEach(function (block) {
        new Box(block);
    });
}

class Box {
    constructor(block) {
        this.block = block;
        this.items = this.block.querySelectorAll('.block-box-item');
        this.init();
    }

    init() {
        this.items.forEach((item, index) => {
            gsap.set(item, {
                y: 500,
            });

            const delay = index * 0.1;

            ScrollTrigger.create({
                trigger: this.block,
                start: "top 50%",
                end: "bottom 50%",
                onEnter: () => {
                    gsap.to(item, {
                        y: 0,
                        duration: 0.5,
                        ease: "power4.out",
                        delay: delay
                    });
                },
            });
        });
    }
}
